<template>
  <div class="headerContainer">
    <div class="asideHeader">
        <span style="line-height: 60px; font-size: 20px;">
            标签打印
        </span>
    </div>
    <div style="display: flex; flex-direction: row;">
      <span style="margin-right: 10px; margin-bottom: 10px; line-height: 60px; font-size: 18px;">{{timeData}}{{weekTime}}</span>
      <el-dropdown @command="handleCommand" class="hamburger">
        <el-button type="text">
          <img src="@/assets/icon_personal.png" class="iconPersonal"/>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>姓名: {{userInfo && userInfo.realName}}</el-dropdown-item>
          <el-dropdown-item>工号: {{userInfo && userInfo.employeeid}}</el-dropdown-item>
          <el-dropdown-item divided command="logout" @mouseover.native="mouseEnter('logout')"
                            @mouseout.native="mouseLeave('logout')"><img :src="logoutIcon" class="drop-image"/><span
            style="vertical-align: middle;">登出</span></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
  import { userLogout } from '@/api/user';
  import moment from 'moment';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        timeInterval: undefined,
        date: moment.utc(),
        chTransform: {
          1: '一',
          2: '二',
          3: '三',
          4: '四',
          5: '五',
          6: '六',
          0: '日',
        },
        logoutIcon: require('@/assets/icon_close.png')
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
      ]),
      timeData() {
        return this.date.local().format('YYYY-MM-DD HH:mm');
      },
      weekTime() {
        const chTransform = this.chTransform;
        return '（星期' + chTransform[this.date.local().format('d')] + '）';
      }
    },
    mounted() {
      this.setTimeInterval(() => {
        this.date = moment.utc();
      }, 1000);
      window.onbeforeunload = () => {
        this.timeInterval && clearTimeout(this.timeInterval);
      };
    },
    destroyed() {
      this.timeInterval && clearTimeout(this.timeInterval);
    },
    methods: {
      setTimeInterval(fn, millisec) {
        if (this.timeInterval) {
          clearTimeout(this.timeInterval)
        }
        const interval = () => {
          this.timeInterval = setTimeout(interval, millisec);
          fn();
        };
        this.timeInterval = setTimeout(interval, millisec);
      },
      async loginOut() {
        try {
          await userLogout();
          this.$store.commit('user/removeToken');
          window.location.reload();
        } catch (e) {
          console.log(e);
        }
      },
      handleCommand(arg) {
        if (arg === 'logout') {
          this.loginOut();
        }
      },
      mouseEnter(arg) {
        if (arg === 'logout') {
          this.logoutIcon = require('@/assets/icon_close_active.png');
        }
      },
      mouseLeave(arg) {
        if (arg === 'logout') {
          this.logoutIcon = require('@/assets/icon_close.png');
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  .headerContainer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    color: white;
    height: 60px;
    background-color: #0E1C3B;
    padding: 0 20px 0 10px;
    position: relative;
    border-bottom: #0A1630 5px solid;
  }

  .asideHeader {
    color: #FFF;
    height: 60px;
    font-size: 24px;
    text-align: center;
  }

  .hamburger {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .drop-image {
    width: 14px;
    height: 14px;
    margin-right: 5px;
    vertical-align: middle;
  }
</style>
